import React from 'react';
import { PriceString } from '@fourthwall/components';
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString';
import { getGiftCardTitle } from '../../utils/getGiftCardTitle';
import { isGiftCardSingle } from '../../utils/isGiftCardSingle';
import * as S from './GiftCardTableCell.styled';
export const GiftCardTableCell = ({ giftCard }) => {
    const renderExpirationLabel = () => {
        if (!giftCard.expiresAt) {
            return null;
        }
        const nonExpiredLabel = isGiftCardSingle(giftCard) ? 'Expires' : 'Expire';
        const expiresLabel = giftCard.status === 'EXPIRED' ? 'Expired' : nonExpiredLabel;
        return (React.createElement(React.Fragment, null,
            "(",
            expiresLabel,
            ' ',
            React.createElement(TimezonedDateString, { date: giftCard.expiresAt, format: "h:mm A, MMM d, YYYY", withTimezoneAbbreviation: false }),
            ")"));
    };
    const renderGiftCardPrice = () => {
        if (isGiftCardSingle(giftCard)) {
            return React.createElement(PriceString, { ...giftCard.initialAmount });
        }
        return (React.createElement(PriceString, { value: giftCard.initialAmount.value / giftCard.codes.length, currency: giftCard.initialAmount.currency }));
    };
    const renderGiftCardSummary = () => {
        if (isGiftCardSingle(giftCard)) {
            return (React.createElement(React.Fragment, null,
                renderGiftCardPrice(),
                " gift card ",
                renderExpirationLabel()));
        }
        return (React.createElement(React.Fragment, null,
            giftCard.codes.length,
            " x ",
            renderGiftCardPrice(),
            " gift card ",
            renderExpirationLabel()));
    };
    return (React.createElement("div", null,
        React.createElement(S.Title, null, getGiftCardTitle(giftCard)),
        React.createElement(S.Summary, null, renderGiftCardSummary())));
};
